import { environment } from '@environment';
import { APP_ROUTES as ROUTES } from './app.routes';
import { EAPP_FLOWS } from './core/enums/app.enum';

export const APP_CONSTANTS = {
  PROP_URL_TOKEN: 'token',
  PROP_URL_TRASACTION_ID: 'tx',
  QUERY_PARAM_AMOUNT: 'price',
  PROP_STORAGE_VISITOR: 'prop.bbva.visitor',
  PROP_HOUR_TOKEN: 'prop.bbva.session-hour-token',
  PROP_SESSION_TOKEN: 'prop.bbva.session-token',
  PROP_CUSTOMER: 'prop.bbva.customer',
  PROP_TRANSACTION_ID: 'prop.bbva.transaction-id',
  PROP_TRANSACTION_TOKEN: 'prop.bbva.transaction-token',
  PROP_TRANSACTION_MIN: 'prop.bbva.transaction-min',
  PROP_TRANSACTION_MAX: 'prop.bbva.transaction-max',
  PROP_TRANSACTION_AMOUNT: 'prop.bbva.transaction-amount',
  PROP_USER_STEP: 'prop.bbva.user-step',
  SIZE_MOBILE_SCREEN: 990,
  SIZE_LARGE_SCREEN: 768,
  TERMS_CONDITIONS_VERSION: '1.0.0',
  LISTEN_KYC_STATUS: 5000,
  TIME_SCORE_LOOP: 2000,
  VALIDATION_REQUEST_LOOP: 4000,
  BIOMETRICS_REQUEST_LOOP: 3000,
  ORDER_TIME_POLL: 1000,
  MIN_VALUE_PURCHASE: '200000',
  MAX_VALUE_PURCHASE: '3000000',
  TIMER_SECONDS: 180,
  TIMER_PENALTY_SECONDS: 360,
  TIMER_MAX_RETRIES: 3,
  MAX_SIZE_FILE: 50 * 1024 * 1024,
  PASSWORD_TOKEN: 'is-password-token',
  TIME_WAITING_IN_FILTERS: 500,
  BBVA_PRODUCT_NAME: 'Powerpay',
  BBVA_PDF_DUMMIE: 'https://bbva-bnpl-pe-alpha-assets-test.s3.amazonaws.com/lorem-ipsum.pdf',
  BBVA_PDF_PRIVACY_POLICY:
    'https://bbva-bnpl-pe-alpha-assets-test.s3.amazonaws.com/lorem-ipsum.pdf',
  BBVA_PDF_TERMS_AND_CONDITIONS:
    'https://bbva-bnpl-pe-alpha-assets-test.s3.amazonaws.com/lorem-ipsum.pdf',
  BBVA_PDF_COLLECTION_POLICY:
    'https://bbva-bnpl-pe-alpha-assets-test.s3.amazonaws.com/lorem-ipsum.pdf',
  RECAPTCHA_PRIVACY_POLICY: 'https://policies.google.com/privacy',
  RECAPTCHA_SERVICE_TERMS: 'https://policies.google.com/terms',
  POWERPAY_PRIVACY_POLICY:
    'https://bbva-bnpl-pe-alpha-assets-test.s3.amazonaws.com/Powerpay_PoliticaPrivacidad.pdf',
  POWERPAY_CONTACT_PHONE_NUMBER: '(01) 7304556',
  COUNTRY_SETUP: {
    SIGN_CURRENCY: '$',
    THOUSAND_SEPARATOR: /\'/g,
    LANGUAGE: 'es_CO',
    CODE: 'CO',
    NUMBER_CODE: '+57',
  },

  TEST_INFO: {
    TOKEN: '12345',
    EMAIL: 'email@email.com',
    USER: '0000000000',
  },

  HTTP_CODES: {
    NOT_FOUND: 404,
    FORBIDDEN: 403,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    INTERNAL_SERVER: 500,
    TIME_OUT: 503,
    CONFLICT: 409,
    OK: 200,
    SUCCESS: '00',
    ERROR: 0,
  },

  MESSAGES: {
    ERROR: 'Ha ocurrido un error vuelve a intentar de nuevo',
    ERROR_NOT_FOUND_RESOURCE: 'El recurso solicitado no está disponible, intente nuevamente',
    SESSION_FINISHED: 'La sesión es inválida o ha finalizado! Por favor ingresa de nuevo más tarde',
    TRANSACTION_TOKEN_UNEXIST: 'La sesión es inválida o ha finalizado!',
    ERROR_FIELD_REQUIRED: 'You must complete all the fields',
    KILL_PURCHASE_LOWER_SCORE: 'The score is lower than transaction amount',
    UNAVAILABLE_SCORE: 'The score is not available',
    LESS_TRANSACTION: 'The transaction amount is less than the min available value',
    GREATER_TRANSACTION: 'The transaction amount is greater than the max available value',
    SCORE_ZERO: 'The user score is zero',
  },

  FLOWS_BY_ROUTE: {
    [ROUTES.WAITING_ROOM]: EAPP_FLOWS.OFFERS,
    [ROUTES.OFFERS]: EAPP_FLOWS.OFFERS,
    [ROUTES.AUTH]: EAPP_FLOWS.AUTH,
    [ROUTES.ONBOARDING]: EAPP_FLOWS.ONBOARDING,
    [ROUTES.FAST_ONBOARDING_STEP_1]: EAPP_FLOWS.FAST_ONBOARDING,
    [ROUTES.FAST_ONBOARDING_STEP_2]: EAPP_FLOWS.FAST_ONBOARDING,
    [ROUTES.SCORE]: EAPP_FLOWS.SCORE,
    [ROUTES.INSTALLMENTS]: EAPP_FLOWS.INSTALLMENTS,
    [ROUTES.PAYMENT]: EAPP_FLOWS.PAYMENT,
    [ROUTES.ERROR]: EAPP_FLOWS.ERROR,
    [ROUTES.CALCULATE]: EAPP_FLOWS.CALCULATE_SCORE,
    [ROUTES.FREQUENT_QUESTIONS]: EAPP_FLOWS.FQA,
    [ROUTES.FREQUENT_QUESTIONS_SCORE]: EAPP_FLOWS.FQA,
    [ROUTES.VALIDATIONS]: EAPP_FLOWS.VALIDATIONS,
    [ROUTES.COMPLETED_PROFILE]: EAPP_FLOWS.COMPLETED_PROFILE,
    [ROUTES.CARD_VALIDATION]: EAPP_FLOWS.CARD_VALIDATION,
    [ROUTES.PURCHASELESS_ONBOARDING]: EAPP_FLOWS.ONBOARDING_WITHOUT_PURCHASE,
    [ROUTES.PAYMENT_PLAN]: EAPP_FLOWS.PAYMENT_PLAN,
  },

  EVENT_BY_FLOW: {
    [EAPP_FLOWS.AUTH]: 'Autenticacion',
    [EAPP_FLOWS.ONBOARDING]: 'Registro',
    [EAPP_FLOWS.FAST_ONBOARDING]: 'Registro_Rapido',
    [EAPP_FLOWS.SCORE]: 'Score',
    [EAPP_FLOWS.INSTALLMENTS]: 'Pago_Resumen',
    [EAPP_FLOWS.PAYMENT]: 'Pago_Exitoso',
  },

  DOCUMENTS: {
    PRIVACY_POLICY: `${environment.documents_bucket}/keo-politica-privacidad.pdf`,
    END_USER_LICENSE_AGREEMENT: `${environment.documents_bucket}/end_user_license_agreement.pdf`,
    ESIGN_DISCLOSURE: `${environment.documents_bucket}/esign_disclosure.pdf`,
  },

  CIVIL_STATUS_MAP_ES_EN: {
    soltero: 'single',
    casado: 'married',
    viudo: 'widower',
    divorciado: 'divorced',
  },

  CIVIL_STATUS_MAP_EN_ES: {
    single: 'soltero',
    married: 'casado',
    widower: 'viudo',
    divorced: 'divorciado',
  },
};
